import { useMyInfo } from 'shared/src/queries';
import { useGoodsCouponRedeemAll } from '../queries/useGoodsCouponRedeemAll';
import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import { useLogCompleteDownloadCouponAll } from './useLogCompleteDownloadCouponAll';
import type { GoodsCoupon } from 'shared/src/api';
import { useLogDownloadCoupon } from './useLogDownloadCoupon';

export const useOnPressGoodsCouponRedeemAll = (coupons: GoodsCoupon[]) => {
  const { mutateAsync: redeemAllCoupon, isPending: loadingRedeemAllCoupon } =
    useGoodsCouponRedeemAll();
  const { data: myInfo } = useMyInfo();
  const logCompleteDownloadAll = useLogCompleteDownloadCouponAll();
  const logCompleteDownloadCoupon = useLogDownloadCoupon();

  return {
    loading: loadingRedeemAllCoupon,
    action: useCallback(async () => {
      if (!myInfo) return;
      if (myInfo.is_anonymous) {
        bridge.assertLogin({});
        bridge.toast('로그인이나 회원가입이 필요해요');
        return;
      }

      redeemAllCoupon()
        .then(logCompleteDownloadAll)
        .then(() => {
          coupons.forEach(coupon => {
            logCompleteDownloadCoupon({ coupon: coupon, isDownloadAll: true });
          });
        });
    }, [
      coupons,
      logCompleteDownloadAll,
      logCompleteDownloadCoupon,
      myInfo,
      redeemAllCoupon,
    ]),
  };
};
